import { classNames as primereactClassNames } from "primereact/utils";

export default primereactClassNames;
